import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


const routes: Routes = [
  {
    path: "cargue",
    loadChildren: () => import('src/app/modules/admin/modules/presupuesto/modules/cargue/cargue.module').then(m => m.CargueModule),
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes),],
  exports: [RouterModule]
})
export class PresupuestoRoutingModule { }